(function ($) {
    let args = $.extend(true, {}, window.accorBookingArgs);

    /** Function that makes a block visible (rooms or children_ages) and updates the tabindex to make the buttons inside it accessible
     *
     * @param wrap
     */
    function show_inner_wrap(wrap) {
        if (wrap.hasClass('visible')) {
            return;
        }
        wrap.stop();
        var parent_inner_wraps = wrap.closest('.inner_wrap');
        var inner_wrap = wrap.find('> .inner_wrap');
        var inner_wrap_height = inner_wrap.outerHeight();
        wrap/*.animate({
            height: inner_wrap_height
        })*/.addClass('visible').css('height', inner_wrap_height+'px');

         wrap.find('.button_range[data-function="plus"]').attr('tabindex', 0);

        if(parent_inner_wraps.length > 0){
            parent_inner_wraps.each(function () {
                var parent = $(this).parent();
                parent.stop();
                var height = parent.outerHeight() + inner_wrap_height;
                parent.animate({
                    height: height
                });
            });
        }
    }


    /** Function that makes a block hidden (rooms or children_ages) and updates the tabindex to make the buttons inside it no longer accessible
     */
    function hide_inner_wrap(wrap) {
        wrap.stop();
        var parent_inner_wraps = wrap.closest('.inner_wrap');
        var wrap_height = wrap.outerHeight();
        wrap.animate({
            height: 0
        }).removeClass('visible');

        if(parent_inner_wraps.length > 0){
            parent_inner_wraps.each(function () {
                var parent = $(this).parent();
                parent.stop();
                var height = parent.outerHeight() - wrap_height;
                parent.animate({
                    height: height
                });
            });
        }

        if(wrap.hasClass('ages_wrap')) {
            var select_to_tabindex = wrap.find('select');
            select_to_tabindex.each(function(){
                $(this).attr('tabindex', '-1');
            });
        }
    }

    function show_child(wrap) {
        wrap.addClass('visible');
        wrap.find('select').attr('tabindex', '0');
    }

    function hide_child(wrap) {
        wrap.find('select').attr('tabindex', '-1');
        wrap.removeClass('visible');
    }

    function isDate(dateVal) {
        var dateParts = dateVal.split("/");

        // month is 0-based, that's why we need dataParts[1] - 1
        var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

        var d = new Date(dateObject);
        return d.toString() == 'Invalid Date'? false: true;
    }


    /** Function that updates the number of rooms and guests, displayed in the drop-down menu placeholder
     *
     * @param event
     * @param isRoomSelector
     * @param parent
     */
    function updatePlaceholderRoomsGuests(event, isRoomSelector, parent){
        var currentValue = $(event).val();
        var sumRanges = 0;
        if(isRoomSelector){
            var label_rooms = (parseInt(currentValue) === 1)? window.label_single_room : window.label_more_rooms;

            $('.placeholder_occupancy .occupancy_rooms').text(currentValue +' '+ label_rooms);
        }

        $('.room_wrap.visible').find('input[type="range"]').each(function(){
            sumRanges += parseInt($(this).val());
        });
        var label_guests = (parseInt(sumRanges) === 1)? window.label_single_guest : window.label_more_guests;

        $('.placeholder_occupancy .occupancy_guests').text(sumRanges +' '+ label_guests);
        parent.find('.quantity-widget__text').text(currentValue);
    }


    function plusMinusRooms(){
        let isRoomSelector = false;

        //init all inputs
        $('input[type="range"]').each(function(){
            var parent = $(this).closest('.dropdown_row');
            isRoomSelector = (parent.hasClass('room_container'));
            changeRangeValue($(this), 'minus', parent);
            updatePlaceholderRoomsGuests('#'+ $(this).attr('id'), isRoomSelector, parent);
        })

        //updates values and labels when any button +/- is clicked
        $(".button_range").click(function(event) {
            var parent = $(this).closest('.dropdown_row');
            isRoomSelector = (parent.hasClass('room_container'));
            var inputRange = parent.find('input[type="range"]');
            changeRangeValue(inputRange, $(this).data('function'), parent);

            updatePlaceholderRoomsGuests('#'+ inputRange.attr('id'), isRoomSelector, parent);
        });


        /**
         * When a +/- button is clicked, the value is updated, disabled if it has reached the minimum/maximum value
         * If the button belongs to the room selector, the relative section is shown/hidden
         *
         * @param inputRange
         * @param direction
         * @param parent
         */
        function changeRangeValue(inputRange, direction, parent) {
            var step = parseInt(inputRange.attr('step'), 10);
            var min = parseInt(inputRange.attr('min'), 10);
            var max = parseInt(inputRange.attr('max'), 10);
            var currentSliderValue = parseInt(inputRange.val(), 10);
            var newStepValue = currentSliderValue;

            var minus = parent.find('a[data-function="minus"]');
            var plus = parent.find('a[data-function="plus"]');
            if (direction === "minus"){
                newStepValue = currentSliderValue - step;
                minus.removeClass('disabled').attr('tabindex', 0);
                if(currentSliderValue - step <= parseInt(min)){
                    minus.addClass('disabled').attr('tabindex', -1);
                    newStepValue = min;
                } else {
                    plus.removeClass('disabled').attr('tabindex', 0);
                }
            } else {
                newStepValue = currentSliderValue + step;

                if(currentSliderValue + step >= parseInt(max)){
                    plus.addClass('disabled').attr('tabindex', -1);
                    newStepValue = max;
                } else {
                    minus.removeClass('disabled').attr('tabindex', 0);
                }

            }
            inputRange.val(newStepValue).change();
            parent.find('select').val(newStepValue).change();

            if(isRoomSelector){
                $('.bookingform').each(function(){
                    var bookingform = $(this);
                    for (var i= 1; i <= args.maxrooms; i++) {
                        var selector = '.room_' + i + '_wrap';
                        var room_wrap = bookingform.find(selector);
                        if ( i <= newStepValue) {
                            show_inner_wrap(room_wrap);
                        } else {
                            hide_inner_wrap(room_wrap);
                        }
                    }
                });
            }
        }
    }

    jQuery(document).ready(function () {

        var bookingforms = $('.bookingform');
        bookingforms.each(function () {
            var bookingform = $(this);

            //Read configuration from data-args
            var maybe_local_config = bookingform.data('args');
            if (maybe_local_config) {
                args = $.extend(args, maybe_local_config);
            }

            /** if the amount of children is changed, the relative age selectors are shown/hidden */
            var children_ranges = bookingform.find('.quantity_children input[type="range"]');
            children_ranges.change(function () {
                var select = $(this);
                var this_room = select.closest('.room_wrap');
                var ages_wrap = this_room.find('.ages_wrap');
                var val = parseInt(select.val());
                var prev_val = select.data('prev_val') || 0;
                select.data('prev_val', val);
                if (val === 0) {
                    hide_inner_wrap(ages_wrap);
                } else {
                    if (ages_wrap.hasClass('vertical')) {
                        show_ages_wrap(ages_wrap, val, prev_val);
                    }
                    for (var i=1; i <= args.maxchildren; i++) {
                        var selector = '.child_' + i + '_field';
                        var single_age = ages_wrap.find(selector);
                        if ( i <= val) {
                            show_child(single_age);
                        } else {
                            hide_child(single_age);
                        }
                    }
                }
            });

            handleDatepickers(bookingform);
        });

        /** by clicking (or pressing keyboard 'enter') on the placeholder, the dropdown for the occupancy is opened */
        $('.placeholder_occupancy').on('click' , function(){
            $('.container_dropdown_occupancy').toggleClass('opened');
            var expanded = ($('.container_dropdown_occupancy').hasClass('opened'));
            $(this).attr('aria-expanded', expanded);
        });
        document.addEventListener("keydown", function(event) {
            if (event.which == 9) {
                $('.placeholder_occupancy').focus(function () {
                    $('.container_dropdown_occupancy').toggleClass('opened');
                    var expanded = ($('.container_dropdown_occupancy').hasClass('opened'));
                    $(this).attr('aria-expanded', expanded);
                });
            }
        });
        if(!is_mobile){
            plusMinusRooms();
            $('.placeholder_occupancy').trigger('click');
        } else {
            //inputs initialized only after click on the button that opens the popup with the BF
            $('.main_book').click(function(){
                plusMinusRooms();
                $('.placeholder_occupancy').trigger('click');
            })
        }

    });

    function handleDatepickers(bookingform) {
        function resetDate(date) {
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            date.setMilliseconds(0);
            return date;
        }
        var checkinField = bookingform.find('input[name=checkInDate]');
        var checkoutField = bookingform.find('input[name=checkOutDate]');
        var checkinDP = bookingform.find('input[name=checkInDateDP]');
        var checkoutDP = bookingform.find('input[name=checkOutDateDP]');
        if (checkinField.length && checkinDP.length && checkoutField.length && checkoutDP.length) {
            var one_day = 86400000;
            var today = resetDate(new Date());
            var minCheckin = today;
            var maxCheckin = new Date(today.getTime() + 400 * one_day);
            var maxCheckout = new Date(today.getTime() + 401 * one_day);
            var timestamp;
            var dateFormatI18N = 'dd/mm/yy';
            if (checkinDP.data('dateformat')) {
                dateFormatI18N = checkinDP.data('dateformat');
            }
            if (checkinDP.data('mindate')) {
                timestamp = parseInt(checkinDP.data('mindate'));
                timestamp = !isNaN(timestamp) ? timestamp * 1000 : 0;
                if (timestamp > today) {
                    minCheckin = resetDate(new Date(timestamp));
                }
            }
            var minCheckout = new Date(minCheckin.getTime() + one_day );
            if (checkinDP.data('maxdate')) {
                timestamp = parseInt(checkinDP.data('maxdate'));
                timestamp = !isNaN(timestamp) ? timestamp * 1000 : 0;
                if (timestamp > minCheckout) {
                    maxCheckin = resetDate(new Date(timestamp));
                    maxCheckout = new Date(maxCheckin.getTime() + one_day);
                }
            }

            var currentCheckin = minCheckin;
            var currentCheckout = minCheckout;
            var checkinFormattedStd, checkinFormattedI18n, checkoutFormattedStd, checkoutFormattedI18n;

            function formatAndDisplayDates() {
                var i18nFormat = checkinDP.datepicker('option', 'dateFormat');

                checkinFormattedStd = $.datepicker.formatDate('dd/mm/yy', currentCheckin);
                checkinFormattedI18n = $.datepicker.formatDate(i18nFormat, currentCheckin);
                checkoutFormattedStd = $.datepicker.formatDate('dd/mm/yy', currentCheckout);
                checkoutFormattedI18n = $.datepicker.formatDate(i18nFormat, currentCheckout);

                checkinDP.val(checkinFormattedI18n);
                checkoutDP.val(checkoutFormattedI18n);

                checkinField.val(checkinFormattedStd);
                checkoutField.val(checkoutFormattedStd);
            }

            checkinDP.datepicker({
                dateFormat: dateFormatI18N,
                dayNamesMin: $.datepicker._defaults.dayNamesShort,
                minDate:minCheckin,
                maxDate: maxCheckin,
                onSelect: function () {
                    currentCheckin = checkinDP.datepicker('getDate');
                    if (currentCheckout <= currentCheckin) {
                        minCheckout = new Date(currentCheckin.getTime() + one_day);
                        currentCheckout = minCheckout;
                        checkoutDP.datepicker('option', 'minDate', minCheckout);
                        checkoutDP.datepicker('setDate', currentCheckout);
                    }
                    formatAndDisplayDates();
                }
            });

            checkoutDP.datepicker({
                dateFormat: dateFormatI18N,
                dayNamesMin: $.datepicker._defaults.dayNamesShort,
                minDate:minCheckout,
                maxDate: maxCheckout,
                onSelect: function () {
                    currentCheckout = checkoutDP.datepicker('getDate');
                    formatAndDisplayDates();
                }
            });

            formatAndDisplayDates();
        } else {
            window.console && console.log('Bookingform without minimum date fields', bookingform);
        }
    }



    function show_ages_wrap(wrap, n_children, prev_val) {
        wrap.stop();
        var parent_inner_wraps = wrap.parents('.inner_wrap');
        var inner_wrap = wrap.find('> .inner_wrap');
        var single_age_height = inner_wrap.find('.child_field').eq(0).outerHeight();
        var previous_height = 0;
        if (prev_val > 0) {
            previous_height = wrap.outerHeight();
        }
        var verticalPadding = inner_wrap.outerHeight() - inner_wrap.height();
        var inner_wrap_height = inner_wrap.find('.title_field').outerHeight(true)
            + verticalPadding
            + ( n_children * single_age_height );
        wrap.animate({
            height: inner_wrap_height
        }).addClass('visible');
        parent_inner_wraps.each(function () {
            var parent = $(this).parent();
            parent.stop();
            var height = parent.outerHeight() + inner_wrap_height - previous_height;
            parent.animate({
                height: height
            });
        });
    }



    $('form.bookingform input[type="submit"]').on('click', function(e){
        var checkin = $('#checkInDateDP').val();
        var checkout = $('#checkOutDateDP').val();
        var destination = $('#select_destination').val();

        if( !(isDate(checkin)) || !(isDate(checkout)) || destination === null){
            e.stopPropagation();
            $('form.bookingform').addClass('dedgebooking_invalid');

            if(! isDate(checkin)){
                $('.arrival_field').addClass('error_date');
                if(!is_mobile){
                    $('#checkInDateDP').focus();
                }
            }
            if(! isDate(checkout)){
                $('.departure_field').addClass('error_date');
                if(!is_mobile){
                    $('#checkOutDateDP').focus();
                }
            }
            if(destination === null){
                $('.destination_field').addClass('error_date');
                if(!is_mobile){
                    $('#select_destination + .select2').focus();
                }
            }
        } else {
            $('input[name="checkInDate"]').val(checkin);
            $('input[name="checkOutDate"]').val(checkout);
            $('form.bookingform').removeClass('dedgebooking_invalid');
            $('.arrival_field, .departure_field, .destination_field').removeClass('error_date');
        }

    })

})(jQuery);